import { cn } from '@/utils/cn';

/**
 * Spieler-Avatar: Minecraft-Kopf (mc-heads.net). Bei Steam-Spielen (ARK)
 * stattdessen ein Initialen-Badge - ein Minecraft-Skin zum ARK-Namen zeigte
 * sonst den Kopf eines fremden Minecraft-Spielers.
 */
export const PlayerAvatar = ({ name, size, steam, className }: { name: string; size: number; steam?: boolean; className?: string }) => {
  if (steam) {
    return (
      <div
        className={cn('flex items-center justify-center rounded-md bg-ember/15 text-ember font-bold shrink-0 select-none', className)}
        style={{ width: size, height: size, fontSize: Math.max(10, Math.round(size * 0.42)) }}
        aria-label={name}
      >
        {(name.trim()[0] || '?').toUpperCase()}
      </div>
    );
  }
  return (
    <img
      src={`https://mc-heads.net/avatar/${encodeURIComponent(name)}/${size}`}
      alt={name}
      className={cn('rounded-md shrink-0', className)}
      style={{ width: size, height: size, imageRendering: 'pixelated' }}
    />
  );
};
